import React, { useEffect, useState } from "react";
import Select from "react-select";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";
import {
  Card,
  Row,
  CardBody,
  Col,
  FormGroup,
  Label,
  Button,
  Alert,
  FormText
} from "reactstrap";
import { useFetch } from "../../utils/fetchHook";
import { getCookie } from "../../jwt/_helpers/cookie";
import ModalConfirm from "../../components/modalConfirm";
import { Redirect } from "react-router-dom";
import { Trans,useTranslation } from "react-i18next";
import "react-day-picker/lib/style.css";

const FeatureAdd = () => {
  const token = getCookie("token");
  const { t } = useTranslation();
  const [listRelease] = useFetch("GET", "releases/?page_size=9999&fields=name,id,official_date", token);
  const [listFeature] = useFetch("GET", "feature-request/", token);
  const [optionList, setOpinionList] = useState(null);

  //ajax handlers
  const [success, setSuccess] = useState(false);
  const [errorPut] = useState(false);
  const [openModal, setToggleModal] = useState(false);
  const [dataModal, setDataModal] = useState(null);
  const [redirect, setRedirect] = useState(false);

  const today = new Date();
  const datePlus = new Date(new Date().setDate(today.getDate() + 11));

  const formattedDate =
    datePlus.getFullYear() +
    "-" +
    ("0" + (datePlus.getMonth() + 1)).slice(-2) +
    "-" +
    ("0" + datePlus.getDate()).slice(-2);

  useEffect(() => {
    if (listRelease.length !== 0) {
      setOpinionList(
        listRelease.results
          .filter(
            i => i.official_date >= formattedDate && listRelease.results.push(i)
          )
          .map(i => ({ value: i.id, label: i.name }))
      );
    }
  }, [listRelease, formattedDate]);

  const idList = [];

  const getFeatureId = () => {
    if (listFeature.length !== 0) {
      listFeature.results.forEach(function(i) {
        idList.push(i.release);
      });
    }
    return idList;
  };

  getFeatureId();

  return (
    <>
      <Row>
        <Col sm={12}>
          <Card>
            <CardBody>
              <h3>{t("feature.add.title")}</h3>
              <Formik
                initialValues={{
                  release: "",
                  dj_tastemaker: "",
                  radio_support: "",
                  marketing_pr: "",
                  label_reach: "",
                  artist_remixer: "",
                  label: "",
                  release_name: "",
                  // release_date: "",
                  exclusive_date: "",
                  release_artist_name: ""
                }}
                validationSchema={Yup.object().shape({
                  release: Yup.string().required(
                    t("feature.add.form.message.releaseRequired")
                  ),
                  dj_tastemaker: Yup.string(),
                  radio_support: Yup.string(),
                  marketing_pr: Yup.string(),
                  label_reach: Yup.string(),
                  artist_remixer: Yup.string(),
                  label: Yup.string(),
                  release_name: Yup.string(),
                  // release_date: Yup.string(),
                  exclusive_date: Yup.string(),
                  release_artist_name: Yup.string()
                })}
                onSubmit={(
                  {
                    release,
                    dj_tastemaker,
                    radio_support,
                    marketing_pr,
                    label_reach,
                    artist_remixer,
                    label,
                    release_name,
                    // release_date,
                    // exclusive_date,
                    release_artist_name
                  },
                  { setStatus, setSubmitting }
                ) => {
                  setStatus();
                  const body = {
                    release: release.value,
                    dj_tastemaker: dj_tastemaker,
                    radio_support: radio_support,
                    marketing_pr: marketing_pr,
                    label_reach: label_reach,
                    artist_remixer: artist_remixer,
                    label: label,
                    release_name: release_name,
                    // release_date: release_date,
                    // exclusive_date: exclusive_date,
                    release_artist_name: release_artist_name
                  };
                  setToggleModal(true);
                  setDataModal(body);
                }}
                render={({
                  errors,
                  status,
                  touched,
                  isSubmitting,
                  setStatus,
                  setFieldValue
                }) => {
                  return (
                    <Form className="mt-3" id="addFeatureAdd">
                      <FormGroup row>
                        <Label for="recSelect" sm={3}>
                          {t("feature.add.form.label.release")}
                        </Label>
                        <Col sm={9}>
                          <Select
                            components={{ IndicatorSeparator:() => null }}
                            options={optionList}
                            placeholder={t("general.asyncDropdown.placeholder")}
                            loadingMessage={() => t("general.asyncDropdown.loading")}
                            noOptionsMessage={() => t("general.asyncDropdown.noResults")} 
                            onChange={e => {
                              if (idList.includes(e.value)) {
                                errors.release = t("feature.add.form.message.featureRequestAlreadyExists");
                                setStatus(errors);
                              } else {
                                setFieldValue("release", e);
                              }
                              return errors;
                            }}
                          />
                          {errors.release && (
                            <div
                              className="invalid-feedback"
                              style={{ display: "block" }}
                            >
                              {errors.release}
                            </div>
                          )}
                          <FormText>
                            {t("feature.add.form.help_text.release")}
                          </FormText>
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="dj_tastemaker" sm={3}>
                          {t("feature.add.form.label.djTastemaker")}
                        </Label>
                        <Col sm={9}>
                          <Field
                            name="dj_tastemaker"
                            component="textarea"
                            rows="5"
                            className={
                              "form-control" +
                              (errors.dj_tastemaker && touched.dj_tastemaker
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="dj_tastemaker"
                            component="div"
                            className="invalid-feedback"
                          />
                          <FormText>
                            {t("feature.add.form.help_text.djTastemaker")}
                          </FormText>
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="radio_support" sm={3}>
                          {t("feature.add.form.label.radioSupport")}
                        </Label>
                        <Col sm={9}>
                          <Field
                            name="radio_support"
                            component="textarea"
                            rows="5"
                            className={
                              "form-control" +
                              (errors.radio_support && touched.radio_support
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="radio_support"
                            component="div"
                            className="invalid-feedback"
                          />
                          <FormText>
                            {t("feature.add.form.help_text.radioSupport")}
                          </FormText>
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="marketing_pr" sm={3}>
                          {t("feature.add.form.label.marketingPR")}
                        </Label>
                        <Col sm={9}>
                          <Field
                            name="marketing_pr"
                            component="textarea"
                            rows="5"
                            className={
                              "form-control" +
                              (errors.marketing_pr && touched.marketing_pr
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="marketing_pr"
                            component="div"
                            className="invalid-feedback"
                          />
                          <FormText>
                            {t("feature.add.form.help_text.marketingPR")}
                          </FormText>
                        </Col>
                      </FormGroup>

                      <FormGroup row>
                        <Label for="label_reach" sm={3}>
                          {t("feature.add.form.label.labelReach")}
                        </Label>
                        <Col sm={9}>
                          <Field
                            name="label_reach"
                            component="textarea"
                            rows="5"
                            className={
                              "form-control" +
                              (errors.label_reach && touched.label_reach
                                ? " is-invalid"
                                : "")
                            }
                          />
                          <ErrorMessage
                            name="label_reach"
                            component="div"
                            className="invalid-feedback"
                          />
                          <FormText>
                            <Trans i18nKey="feature.add.form.help_text.labelReach">
                              The combined ( label and artists) amount of followers on Facebook, Instagram, SoundCloud, and YouTube. <strong>Please put each platform and number of followers in a new row</strong>.
                            </Trans>
                          </FormText>
                        </Col>
                      </FormGroup>

                      <FormGroup>
                        <Button type="submit" color="success">
                          {t("feature.add.form.button.submit")}
                        </Button>
                      </FormGroup>
                    </Form>
                  );
                }}
              />
              {success && (
                <Alert color="success">{t("feature.add.message.success")}</Alert>
              )}
              {redirect ? <Redirect to="/feature" /> : null}
              {errorPut && (
                <Alert color="danger">
                  {t("feature.add.message.error")}
                </Alert>
              )}
            </CardBody>
          </Card>
        </Col>
      </Row>
      {dataModal && (
        <ModalConfirm
          openModal={openModal}
          setToggleModal={setToggleModal}
          dataModal={dataModal}
          title={t("feature.add.modal.confirm.header")}
          setSuccess={setSuccess}
          body={t("feature.add.modal.confirm.body")}
          apiURL={`feature-request`}
          setRedirect={setRedirect}
        />
      )}
    </>
  );
};

export default FeatureAdd;
